import type { CellContentAlignment } from '../model/form.types';
import AlignLeftIcon from '@/shared/assets/icons/AlignLeftIcon.svg';
import AlignCenterIcon from '@/shared/assets/icons/AlignCenterIcon.svg';
import AlignRightIcon from '@/shared/assets/icons/AlignRightIcon.svg';

export interface AlignmentOption {
  value: CellContentAlignment;
  label: string;
  icon: string;
}

export const ALIGNMENT_OPTIONS: AlignmentOption[] = [
  { value: 'left', label: 'Alinhar à esquerda', icon: AlignLeftIcon },
  { value: 'center', label: 'Centralizar', icon: AlignCenterIcon },
  { value: 'right', label: 'Alinhar à direita', icon: AlignRightIcon },
];

export const ALIGNMENT_ICON_MAP: Record<CellContentAlignment, string> = {
  left: AlignLeftIcon,
  center: AlignCenterIcon,
  right: AlignRightIcon,
};
